import React, { useEffect, useRef, useState } from 'react'
import { useSnackbar } from 'notistack'
import { Box } from '@mui/material'
import { useForm } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import postService from '../../services/postService'
import PostForm from './PostForm'

const UpdatePostPage = () => {
  const [tabValue, setTabValue] = useState('text')
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const methods = useForm({ mode: 'onChange' })
  const editorRef = useRef(null)
  const { postId } = useParams()

  useEffect(() => {
    postService.getPostById(postId)
      .then(res => {
        methods.reset({
          communityId: res.communityId,
          title: res.title,
          body: res.body,
          link: res.link
        })
        if (res.body) {
          editorRef.current.setContent(res.body)
        }
      })
      .catch(err => enqueueSnackbar(err, { variant: 'error' }))
  }, [])

  const submitHandler = ({ title, body, images, link }) => {
    const form = { title }
    form.id = postId
    if (tabValue === 'text') {
      form.body = body
      form.images = []
      form.link = ''
    } else if (tabValue === 'images') {
      form.images = images
      form.body = ''
      form.link = ''
    } else if (tabValue === 'link') {
      form.link = link
      form.body = ''
      form.images = []
    }
    return postService.updatePost(postId, {
      ...form
    })
      .then(res => {
        enqueueSnackbar('Successfully updated the post!.', { variant: 'success' })
        navigate('/home')
      })
      .catch(err => enqueueSnackbar(err.response.data.message, { variant: 'error' }))
  }

  return (
    <Box>
      <PostForm postFormTitle="Edit Post" methods={methods} onSubmit={submitHandler} tabValue={tabValue} setTabValue={setTabValue} editorRef={editorRef}/>
    </Box>
  )
}

export default UpdatePostPage
